import { ReactComponentManifest } from "web/entrypoints/common/setup";
import ExpressCheckoutProductPage from "web/react/components/express-checkout-product-page/express-checkout-product-page";
import Footer from "web/react/components/footer/footer";
import ProductArea from "web/react/components/product-area/product-area";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import UnsubscribeOverlay from "web/react/components/unsubscribe-overlay/unsubscribe-overlay";
import UnsubscribeFeedback from "web/react/components/unsubscribe-feedback/unsubscribe-feedback";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import SaleLandingPageLayout from "web/react/components/sale-landing-page-layout/sale-landing-page-layout";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    ExpressCheckoutProductPage,
    Footer,
    OOSProductPage,
    ProductArea: withRedux(ProductArea as any), // TODO: ProductArea's proptypes are broken
    ProductPage,
    RelatedProductsRails,
    RelatedSearchesRail,
    RetailerPromotionHub,
    SaleLandingPageLayout,
    UnsubscribeOverlay,
    UnsubscribeFeedback,
};

export default components;
